import { ROUTES } from '~constants/routes';
import { CLIENT_STEPS_TARGETS } from '~constants/steps';

export const getStepperActions = handleUpdateSimulation => ({
  [CLIENT_STEPS_TARGETS.CLIENT_FINANCIAL_INFORMATION]: handleUpdateSimulation(ROUTES.CLIENT_INCOMES.stepName),
  [CLIENT_STEPS_TARGETS.CLIENT_PERSONAL_DOCUMENTATION]: handleUpdateSimulation(
    ROUTES.CLIENT_PERSONAL_DOCUMENTATION.stepName
  )
});
